import e from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import x from "./iconfont.es5471.js";
const d = {
  display: "block"
}, f = ({ size: a = 16, useVw: n, useRem: c, color: o, withColor: l, removeClassName: t, disableSSR: p, style: i, ...m }) => {
  const h = i ? { ...d, ...i } : d;
  return /* @__PURE__ */ e.createElement(x, { disableSSR: p }, /* @__PURE__ */ e.createElement("svg", { "data-icon-id": "32px-zhanghujiedan", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: n ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (c ? "rem" : "px"), height: n ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (c ? "rem" : "px"), className: t ? "" : "iconpark-icon", style: h, fill: "none", ...m }, /* @__PURE__ */ e.createElement(
    "g",
    {
      className: t ? "" : "32px-è´¦æ·ç»å"
    },
    /* @__PURE__ */ e.createElement(
      "g",
      {
        className: t ? "" : "normal",
        fill: l ? r(o, 0, "#262933") : "#262933",
        datafollowfill: l ? r(o, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ e.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M20.014 3.562c-1.881-.423-3.271 1.193-3.271 2.828v5.477a3.09 3.09 0 0 0 3.09 3.09h5.477c1.635 0 3.251-1.39 2.828-3.27a10.77 10.77 0 0 0-8.124-8.125ZM18.543 6.39c0-.784.597-1.18 1.076-1.072a8.971 8.971 0 0 1 6.763 6.763c.107.48-.289 1.076-1.072 1.076h-5.477a1.29 1.29 0 0 1-1.29-1.29V6.39Z",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M13.53 6.177a.9.9 0 0 0-.358-1.764C7.71 5.522 3.6 10.348 3.6 16.137 3.6 22.744 8.956 28.1 15.563 28.1c5.789 0 10.615-4.11 11.724-9.572a.9.9 0 1 0-1.764-.358c-.942 4.639-5.044 8.13-9.96 8.13C9.95 26.3 5.4 21.75 5.4 16.137c0-4.916 3.491-9.018 8.13-9.96Z"
        }
      )
    )
  )));
}, u = f;
export {
  u as default
};
